import React, { useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import SubmitButton from '../../../components/form/SubmitButton';
import { useLocation, useNavigate } from 'react-router-dom';
import LoadingButton from '../../../components/form/LoadingButton';
import { apiPost } from '../../../utils/api';
import { showError, showSuccess } from '../../../utils/alert';
import { useDispatch } from 'react-redux';
import { getdeviceId } from '../../../utils/auth';
import { loginAdmin } from '../../../redux/adminSlice';
import { fetcher } from '../../../utils/fetchers';
import { PermissionsKey } from '../../../data/permissions';

export default function AdminVerifyOtp() {
    const location = useLocation();
const { phone, redirect } = (location.state as { phone?: string; redirect?: string }) || {};
  const { t } = useTranslation();
  const { handleSubmit } = useForm();
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef<Array<HTMLInputElement | null>>([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (value: string, index: number) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Auto move to next input
      if (value && index < 3) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const onSubmit = async () => {
    try {
      const code = otp.join("");
      if (code.length < 4) {
        showError(t("otp_required") || "Please enter full OTP");
        return;
      }

      setLoading(true);
      const deviceId = getdeviceId();
      const response = await apiPost('otp-code/verify/admin', { code ,phone,deviceId}) as {accessToken:string , refreshToken:string};
      const responseForPermissions = await fetcher('admin/permissions',response.accessToken)as{permissions:PermissionsKey[]};
      showSuccess(t('signin_opt'));
      dispatch(loginAdmin({ refreshToken: response.refreshToken , accessToken:response.accessToken,permissions:responseForPermissions.permissions }));
      navigate(redirect || "/admin", { replace: true });
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      showError(err.message);
    }
  };

  return (
    <div className="min-h-screen w-screen flex justify-center items-center bg-light p-8 md:p-16">
  <div className="w-full max-w-md p-6 md:p-8 bg-white rounded-2xl shadow-lg">
    {/* Title */}
    <h1 className="text-2xl text-center font-bold text-Black mb-2">{t('otp_verify')}</h1>
    <p className="text-center text-Black font-normal mb-1">{t('otp_sent')}</p>
    <p className="text-center text-Black font-semibold mb-5">+{phone}</p>

    {/* OTP Form */}
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-6" dir="ltr">
      <div className="flex justify-center gap-3">
        {otp.map((digit, index) => (
          <input
            key={index}
            ref={(el: HTMLInputElement | null) => { inputRefs.current[index] = el; }}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={digit}
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            className="w-14 h-14 text-center text-xl border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          />
        ))}
      </div>

      {loading
        ? <LoadingButton height={64} />
        : <SubmitButton height={64} label={t('verify_otp') || "Verify OTP"} />
      }
    </form>
  </div>
</div>

  );
}
